import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PeopleListPageComponent } from './pages/list.component';
import { PersonDetailPageComponent } from './pages/detail.component';
import { PeopleNewPageComponent } from './pages/new.component';
import { EditPersonDetailPageComponent } from './pages/edit.component';
import { BulkEditPersonDetailPageComponent } from './pages/bulkedit.component';
import { EditPersonJsonPageComponent } from './pages/edit-json.component';
import { environment } from '../../environments/environment';
import { SynchronizationResolver } from '../utils/syncronization.resolver';
import { CurrentUserResolver } from '../utils/currentPerson.resolver';
import { PermissionGuard } from '../utils/permission.guard';

const appRoute = environment.applicationRoute;

const routes: Routes = [
  {
    path: '',
    resolve: { currentPerson: CurrentUserResolver },
    children: [
      {
        path: appRoute + '/people/new',
        component: PeopleNewPageComponent,
        canActivate: [PermissionGuard],
        data: { permission: 'manage.people' }
      },
      {
        path: appRoute + '/people/edit',
        component: EditPersonDetailPageComponent,
        canActivate: [PermissionGuard],
        data: { permission: 'manage.people' }
      },
      {
        path: appRoute + '/people/bulkedit',
        component: BulkEditPersonDetailPageComponent,
        canActivate: [PermissionGuard],
        data: { permission: 'manage.people' }
      },
      {
        path: appRoute + '/people',
        component: PeopleListPageComponent,
        canActivate: [PermissionGuard],
        data: { permission: 'manage.people' }
      },
      {
        path: appRoute + '/people/:personId/edit',
        component: EditPersonDetailPageComponent,
        canActivate: [PermissionGuard],
        data: { permission: 'manage.people' }
      },
      {
        path: appRoute + '/people/:personId/editjson',
        component: EditPersonJsonPageComponent,
        canActivate: [PermissionGuard],
        data: { permission: 'manage.people' }
      },
      {
        path: appRoute + '/people/:personId',
        component: PersonDetailPageComponent,
        canActivate: [PermissionGuard],
        data: { permission: 'manage.people' }
      }
    ]
  },
  {
    path: '',
    resolve: { synchronizeData: SynchronizationResolver },
    children: [{ path: '', redirectTo: appRoute + '/people', pathMatch: 'full' }]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PeopleRoutingModule {}
export const routedComponents = [PeopleListPageComponent, PersonDetailPageComponent];
